import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';

import { BasicDepartment } from '~hooks/useDepartment/models';

interface DepartmentBadgeProps {
  department?: BasicDepartment;
  sx?: SxProps<Theme>;
}

export default function DepartmentBadge({ department, sx }: DepartmentBadgeProps) {
  const name = department?.name;

  if (!name) {
    return null;
  }

  return (
    <Box
      sx={[
        { alignItems: 'center', display: 'flex', gap: 0.5, maxWidth: '120px' },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Tooltip
        title={name}
        slotProps={{
          popper: { modifiers: [{ name: 'offset', options: { offset: [0, -8] } }] },
        }}
      >
        <Chip
          label={name}
          size="small"
          sx={(theme) => ({
            bgcolor: theme.brandV2.colors.treadGray8,
            border: `1px solid ${theme.brandV2.colors.treadGray7}`,
            borderRadius: '4px',
            color: theme.brandV2.colors.treadBlack,
            fontSize: '12px',
            fontWeight: 600,
          })}
        />
      </Tooltip>
    </Box>
  );
}
